import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route change EXCEPT when the change is purely a language
 * switch (e.g. /mx -> /en or /mx/privacidad -> /en/privacy). The language
 * switcher uses `state: { langSwitch: true }` so we can detect that case.
 */
const stripLang = (path) => {
  if (!path) return "/";
  const parts = path.split("/").filter(Boolean);
  if (parts[0] === "mx" || parts[0] === "en") {
    return "/" + parts.slice(1).join("/");
  }
  return path;
};

export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state && state.langSwitch) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}

export { stripLang };
